import { Button, Drawer } from "components";
import { ToggleProps } from "types";
import DownloadBox from "./DownloadBox";

type Props = ToggleProps;

export default function DownloadAppDrawer({ isOpen, toggle }: Props) {
  return (
    <Drawer isOpen={isOpen} toggle={toggle}>
      <Drawer.Menu>
        <Drawer.Header>
          <h4 className="text-base text-[#353740] font-medium text-center">
            Get the App for a better experience
          </h4>
        </Drawer.Header>
        <Drawer.Body className="pb-12">
          <DownloadBox />
          <Button
            type="button"
            className="block w-fit mt-7 mx-auto"
            onClick={toggle}
          >
            Not interested at this time
          </Button>
        </Drawer.Body>
      </Drawer.Menu>
    </Drawer>
  );
}
